(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["coastous-accessibility-trigger"] && !Shopify.designMode) return;
  try {
    (() => {
    let userwayInstance = window.UserWay;

    const hideFloatingLauncher = instance => {
      userwayInstance = instance || userwayInstance;
      userwayInstance?.iconVisibilityOff?.();
    };

    hideFloatingLauncher(userwayInstance);

    document.addEventListener('userway:init_completed', event => {
      hideFloatingLauncher(event.detail?.userWayInstance);
    });

    document.addEventListener('click', event => {
      if (!event.target.closest('[data-userway-footer-trigger]')) return;
      (userwayInstance || window.UserWay)?.widgetOpen?.();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
